var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.widget)?_c('div',{staticClass:"card m-2 px-4 pt-4",class:_vm.cardSize()},[_c('WidgetTitle',{staticStyle:{"margin-top":"-10px"},attrs:{"title":_vm.widgetTitle,"tooltip":_vm.widgetTooltip}}),_c('WidgetBody',{staticClass:"mb-3",attrs:{"widgetId":_vm.widget._id,"widgetType":_vm.widget.type}})],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }